import { Link } from 'react-router-dom';

import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

type SecurityQuestionsWarningProps = PropsWithClassName<{
  text: string;
  action?: {
    url: string;
    label: string;
  };
}>;

export function SecurityQuestionsWarning({ text, action, className }: SecurityQuestionsWarningProps) {
  return (
      <div className={cn("bg-gradient-to-b from-red-500 to-red-600 rounded px-6 py-4 flex items-center justify-between", className)}>
        <p className="text-red-50 font-medium">{text}</p>
        {action && (
          <Link
            className="bg-red-700 hover:bg-red-800 rounded px-3 py-2 text-red-50 font-medium no-underline"
            to={action.url}
          >
            {action.label}
          </Link>
        )}
    </div>
  );
}
